<template>
  <div class="text-center">
    <div class="text-h3 text-uppercase">Nuevo proyecto</div>
    <v-container class="d-flex justify-center">
      <ProjectNew></ProjectNew>
    </v-container>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import ProjectNew from '@/components/admin/project/ProjectNew'

export default {
  components: { ProjectNew },
  props: {},
  computed: {}
}
</script>
